export default __webpack_public_path__ + "static/logo_main-48ef2c97cb2deb20e028b98c32a64ba2.png";